import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";


const ContactUsPage = () => {
    return (
        <Box>
            <Typography>
                helpus@vcurrent.com
            </Typography>
        </Box>
    );
}

export default ContactUsPage;
